import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../context/AuthContext';

/**
 * ProtectedRoute — 未ログインなら /login へリダイレクト
 *
 * v2: リダイレクト前の元 URL (path + search + hash) を `state.returnTo` で保存。
 *     LoginPage 側で読み取ってログイン後に元の場所に戻れるようにする。
 *     決済中の 401 で ?orderId=... のクエリパラメータが消えて確認画面に戻れない致命傷を防ぐ。
 */
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    const returnTo = `${location.pathname}${location.search || ''}${location.hash || ''}`;
    return <Navigate to="/login" replace state={{ returnTo }} />;
  }

  return children;
};

export default ProtectedRoute;
